import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ScrollToTop from '../ScrollToTop';

// Same layout/classes as PrivacyPolicy.jsx, shared by the new policy pages.
const PolicyShell = ({ title, updated, children }) => {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>{title} | TLK</title>
            </Helmet>
            <ScrollToTop />
            <div className="min-h-screen gradient-bg-1">
                <header className="cs-header">
                    <div className="cs-header-left">
                        <button type="button" className="cs-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                            <ArrowBackIcon fontSize="small" />
                        </button>
                        <div className="cs-title">
                            <span className="cs-bar"></span>
                            <h1>{title}</h1>
                        </div>
                    </div>
                    <div className="cs-updated"> Last updated: {updated}</div>
                </header>
                <div className="p-6 pt-[100px] max-w-2xl mx-auto" style={{ opacity: 1, transform: "none" }}>
                    <div className="space-y-6 text-sm leading-relaxed">{children}</div>
                    <div className="mt-8 pt-6 border-t border-border">
                        <p className="text-xs text-muted-foreground text-center">
                            Copyright 2026 Syntimacy LLC. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PolicyShell;